import { SlackAppRow } from '../components/slack/SlackAppRow';
import type { AppRow } from '../type/AppRow';

export const slackAppRow: AppRow = {
  key: 'slack',
  name: 'Slack',
  AppComponent: SlackAppRow,
};
